import { ForecastSeasonalRiskBase } from './base/forecast-seasonal-risk-base';

export class ForecastSeasonalRisk extends ForecastSeasonalRiskBase { }